// extracted by mini-css-extract-plugin
module.exports = {"infos":"AiItemInfo_infos__sA2yD","prompt":"AiItemInfo_prompt__1Lxa4","modalWrap":"AiItemInfo_modalWrap__h_qyS","likeWiseCost":"AiItemInfo_likeWiseCost__HG2sA"};